export class StatementLink
{
	public Name: string = '';
	public Href: string = '';
}
